import React from "react";
import { iconProps } from "../../../Helper";

export const ClearIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={className}
    >
      <mask
        id="mask0_9035_91526"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9035_91526)">
        <path
          d="M11.3463 11.2501H13.6538V4.09638C13.6538 3.77455 13.5419 3.5018 13.3183 3.27813C13.0946 3.0543 12.8219 2.94238 12.5 2.94238C12.1782 2.94238 11.9054 3.0543 11.6818 3.27813C11.4581 3.5018 11.3463 3.77455 11.3463 4.09638V11.2501ZM5.44228 15.0579H19.5578V13.0579C19.5578 12.9681 19.5289 12.8943 19.4713 12.8366C19.4134 12.779 19.3397 12.7501 19.25 12.7501H5.75003C5.66036 12.7501 5.58661 12.779 5.52878 12.8366C5.47111 12.8943 5.44228 12.9681 5.44228 13.0579V15.0579ZM4.31928 21.0579H6.84628V18.8079C6.84628 18.5954 6.91819 18.4172 7.06203 18.2734C7.20569 18.1297 7.38386 18.0579 7.59653 18.0579C7.80919 18.0579 7.98728 18.1297 8.13078 18.2734C8.27444 18.4172 8.34628 18.5954 8.34628 18.8079V21.0579H11.75V18.8079C11.75 18.5954 11.8219 18.4172 11.9658 18.2734C12.1096 18.1297 12.2878 18.0579 12.5003 18.0579C12.7129 18.0579 12.891 18.1297 13.0345 18.2734C13.1782 18.4172 13.25 18.5954 13.25 18.8079V21.0579H16.6538V18.8079C16.6538 18.5954 16.7257 18.4172 16.8695 18.2734C17.0134 18.1297 17.1916 18.0579 17.4043 18.0579C17.6168 18.0579 17.7949 18.1297 17.9385 18.2734C18.082 18.4172 18.1538 18.5954 18.1538 18.8079V21.0579H20.6808C20.7833 21.0579 20.8666 21.0178 20.9308 20.9376C20.9949 20.8575 21.0109 20.7693 20.9788 20.6731L19.8635 16.5579H5.13653L4.02128 20.6731C3.98911 20.7693 4.00511 20.8575 4.06928 20.9376C4.13344 21.0178 4.21678 21.0579 4.31928 21.0579ZM20.7578 22.5579H4.24228C3.67561 22.5579 3.21478 22.3316 2.85978 21.8789C2.50461 21.4264 2.40394 20.9219 2.55778 20.3654L3.94228 15.2214V13.0001C3.94228 12.5143 4.11253 12.1011 4.45303 11.7606C4.79336 11.4203 5.20644 11.2501 5.69228 11.2501H9.84628V4.09638C9.84628 3.35922 10.1043 2.73255 10.6203 2.21638C11.1363 1.70038 11.7629 1.44238 12.5 1.44238C13.2372 1.44238 13.8638 1.70038 14.3798 2.21638C14.8958 2.73255 15.1538 3.35922 15.1538 4.09638V11.2501H19.3078C19.7936 11.2501 20.2067 11.4203 20.547 11.7606C20.8875 12.1011 21.0578 12.5143 21.0578 13.0001V15.2214L22.4423 20.3846C22.6269 20.9346 22.5391 21.4344 22.1788 21.8839C21.8186 22.3332 21.3449 22.5579 20.7578 22.5579Z"
          fill="#12B6EA"
          className={className}
        />
      </g>
    </svg>
  );
};
